define.alias("ember-power-select/components/power-select/label", "preview-grid/components/power-select/label");